import React from "react";
import { createRoot } from "react-dom/client";
import "@pgs-core/ui/globals.css";
import { App } from "./components/app";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
